import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Blank practice sheets you still have to fill in', 'A pile of loose drills with no order to run them in', 'Monthly app fees just to keep the plans', 'You decide what comes after what, every single week', 'You keep paying for it with the night before'];
const withIt = ['142 practices written out, quarter by quarter', 'One new play or concept installed per week, in order', 'A one-time PDF — print it, no subscription', 'Flag 5v5, 7v7 and youth tackle, by age', "Pick up tomorrow's card and run it"];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-309" data-mp="296pc963sa1j5">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-310" data-mp="2d80x6ybppyl0">
        <div className="text-center" data-id="element-311" data-mp="30yeo2lik9re0">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-312" data-mp="30xbycgwz5uzo">
            Why this isn&apos;t another planner
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-313" data-mp="35qy3zp4q0ylz">
            Blank templates vs{' '}
            <span className="text-crimson-deep" data-id="element-314" data-mp="1oi37dikrx28c">practices already planned</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-315" data-mp="236hck05nx2s2">
            Every planner on the market sells you organization. Organizing was
            never the hard part — deciding what to actually run on Tuesday was.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-ice-dark" data-id="element-316" data-mp="286ls9nyqxth8">
          <div className="bg-ice px-3.5 py-4 sm:p-6" data-id="element-317" data-mp="2m1o6cydqyp54">
            <h3 className="font-display text-base uppercase tracking-wide text-ink-soft sm:text-xl" data-id="element-318" data-mp="2h68wehiv1ddz">
              A blank practice planner
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-319" data-mp="mqwlzanmiec8">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-320" data-mp="2mt5tmrn364s0">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-crimson/15" data-id="element-321" data-mp="2rsiq843req7s">
                    <XIcon className="h-2.5 w-2.5 text-crimson-deep" aria-hidden="true" data-id="element-322" data-mp="2vw6x0kkkhhrz" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-navy px-3.5 py-4 text-white sm:p-6" data-id="element-323" data-mp="3apjv7oxbcqbq">
            <h3 className="font-display text-base uppercase tracking-wide text-gold sm:text-xl" data-id="element-324" data-mp="3fhl739qkkf18">
              Sideline Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-325" data-mp="3jlj67kfw9pua">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-326" data-mp="3okcmfkmkfuy5">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-327" data-mp="7h6ohsjm3t7d">
                    <CheckIcon className="h-2.5 w-2.5 text-gold-hover" aria-hidden="true" data-id="element-328" data-mp="2fhemg84llkv" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}